import App from 'common/backbone-app';

import { ActorContext, TargetEmployee } from './employeeEditPolicy';

export const getActorContext = (): ActorContext => {
  const account = App.config.get('account') ?? {};

  return {
    permissions: account.permissions ?? [],
    roleCode: account.employeeRoleCode ?? null,
    employeeId: App.config.getAccountEmployeeId() ?? null,
    masqueradingAsSupplier: account.masquerade && account.entity?.type === 'SUPPLIER',
  };
};

export const getTargetEmployee = ({
  id,
  role,
  persistedRole,
  permissions,
  supplierBound,
  active,
}: {
  id?: number | null;
  role?: string | null;
  persistedRole?: string | null;
  permissions?: string[];
  supplierBound?: boolean;
  active?: boolean;
}): TargetEmployee => ({
  id: id ?? null,
  role: role ?? null,
  persistedRole: persistedRole ?? null,
  permissions: permissions ?? [],
  supplierBound: supplierBound ?? false,
  active: active ?? true,
});
